<template>
  <div class="screencasts _py-16 _bg-light">
    <div class="container">
      <div
        class="screencasts__title _px-md-4 _mb-6 _fs-24 _lh-32 _tc-dark-grey"
      >
        Выберите формат бизнес-инструментов, которые хотите освоить
      </div>
      <div
        class="screencasts__filter _px-md-4 _mb-8"
        v-if="getScreencastsCategories && getScreencastsCategories.length"
      >
        <div
          class="screencasts-filter__item"
          v-for="(item, i) in filter"
          :key="i"
          :class="{
            'screencasts-filter__item_active': item.slug === currentCategory,
          }"
          @click="choiceCategory(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div
        class="sections__list d-grid row-1-1 gap-32"
        v-if="getScreencastsList && getScreencastsList.length"
      >
        <VideoCard
          @like="like"
          @favorite="favorite"
          @downloadFile="downloadFile"
          @viewItem="viewItem"
          @setVideoProgress="setVideoProgress"
          v-for="(block, ind) in paginationList"
          :key="ind"
          :item="getTranslate(block)"
          :analyticEventPrefix="'intensive_scrncast_material'"
        ></VideoCard>
      </div>
    </div>
    <Pagination
      :itemsCount="getScreencastsList.length"
      @rangeChange="rangeChange"
    />
  </div>
</template>

<script>
import VideoCard from '@/components/UI/cards/VideoCard'
import Pagination from '../../components/UI/pagination/Pagination.vue'
import { mapActions, mapGetters } from 'vuex'
import download from '@/mixins/download'
export default {
  name: 'Screencasts',
  mixins: [download],
  components: {
    VideoCard,
    Pagination,
  },
  data: () => ({
    currentCategory: '',
    startRange: 0,
    endRange: 4,
  }),
  computed: {
    ...mapGetters(['getScreencastsCategories', 'getScreencastsList']),
    filter() {
      let arr = [
        {
          name: 'Все',
          slug: '',
        },
      ]
      let result = arr.concat(
        this.getScreencastsCategories.map(function (el) {
          return {
            name: el.translates[0].name,
            slug: el.slug,
          }
        })
      )
      return result
    },
    paginationList() {
      return this.getScreencastsList.slice(this.startRange, this.endRange)
    },
  },
  methods: {
    ...mapActions([
      'fetchScreencastsCategories',
      'fetchScreencastsList',
      'ScreencastsSetVideoProgress',
      'ScreencastsSetLike',
      'ScreencastsSetFavorite',
      'ScreencastsSetView',
    ]),
    getTranslate(item) {
      return {
        ...item,
        title: item.translates[0].title,
        description: item.translates[0].description,
        preview: item.translates[0].preview,
        file: item.translates[0].video || item.translates[0].link,
        file_size: item.translates[0].video_size,
        extras: item.translates[0].extras,
      }
    },
    rangeChange(start, end) {
      this.startRange = start
      this.endRange = end
    },
    async updateList() {
      await this.fetchScreencastsList({
        lang: this.Trans.currentLocale,
        intensive_slug: this.$route.params.slug,
        category_name: this.currentCategory,
      })
    },
    async like(id) {
      await this.ScreencastsSetLike(id)
      await this.updateList()
    },
    async favorite(id) {
      await this.ScreencastsSetFavorite(id)
      await this.updateList()
    },
    async setVideoProgress(id, time) {
      await this.ScreencastsSetVideoProgress({
        id: id,
        progress: Math.round(time),
      })
      await this.updateList()
    },
    async viewItem(id) {
      await this.ScreencastsSetView(id)
      await this.updateList()
    },
    choiceCategory(category) {
      this.currentCategory = category.slug
      // this.updateList()
      if (category) {
        this.$router.replace({
          query: { category: category.slug },
        })
      } else {
        let query = { ...this.$route.query }
        delete query.category
        this.$router.replace({ query: query })
      }
      if (this.$gtm) {
        this.$gtm.push({
          event: 'intensive_scrncast_filters',
          param_value: this.helpers.stripHtml(category.name),
        })
      }
    },
  },
  async mounted() {
    await this.fetchScreencastsCategories()
    this.currentCategory = this.$route.query?.category || ''
    await this.fetchScreencastsList({
      lang: this.Trans.currentLocale,
      intensive_slug: this.$route.params.slug,
      category_name: this.currentCategory,
    })
  },
  watch: {
    getScreencastsList() {
      if (this.getScreencastsList && !this.getScreencastsList.length) {
        this.$router.push(
          this.helpers.buildRoute({
            name: 'Intensive',
            params: { slug: this.$route.params.slug },
          })
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.screencasts {
  &__filter {
    margin: 0 -8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
}

.screencasts-filter {
  &__item {
    margin: 0 8px;
    padding: 16px;
    border: 2px solid #707372;
    border-radius: 99px;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    color: color(dark-grey);
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      color: color(green-main);
    }

    @media screen and (max-width: 743px) {
      padding: 8px 12px;
      margin-bottom: 16px;
    }

    &_active {
      color: color(dark);
      border-color: color(green-main);
    }
  }
}

.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}
</style>
